import { render, staticRenderFns } from "./ProductPriceDetailsTable.vue?vue&type=template&id=7e53cf68&scoped=true"
import script from "./ProductPriceDetailsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductPriceDetailsTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProductPriceDetailsTable.vue?vue&type=style&index=0&id=7e53cf68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e53cf68",
  null
  
)

export default component.exports